import React from "react";
import RightIcon from '../../assets/logos/RightIcon.svg';
import { Link } from "react-router-dom";
import "../../styles/AgentCard.css";

const AgentCard = ({
  image, title, description, to,
}) => (
  <Link to={to} className="agent-card-link">
    <div className="agent-card">
      <img src={image} alt="" className="agent-avatar" />

      <div className="agent-card-content">
        <div className="agent-title-row">
          <h3 className="agent-title">{title}</h3>
          {/* <img src={RightIcon} alt="rightIcon" className="rightIcon" /> */}
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.84668 13.6934L11.4111 9.12891L6.84668 4.56445" stroke="#9298BA" stroke-width="1.90186" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <p className="agent-description">{description}</p>
      </div>
    </div>
  </Link>
);

export default AgentCard;
